import { render, staticRenderFns } from "./AppOrganizationSettings.vue?vue&type=template&id=1c0d8e04&scoped=true&"
import script from "./AppOrganizationSettings.vue?vue&type=script&lang=js&"
export * from "./AppOrganizationSettings.vue?vue&type=script&lang=js&"
import style0 from "./AppOrganizationSettings.vue?vue&type=style&index=0&id=1c0d8e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d8e04",
  null
  
)

export default component.exports